import React, { memo, useCallback } from "react";
import { Button } from "@chakra-ui/react";
import colors from "app/colors";
import { OrderedListIcon } from "modules/icons";
import { IQuillFormats } from "modules/quill/use-quill";

interface IProps {
  format: (name: string, value: any) => void;
  activeFormats: IQuillFormats;
}

const ComposeQuillOrderedList = ({ format, activeFormats }: IProps) => {
  const isSelected = activeFormats.list === "ordered";

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (format) {
        format("list", isSelected ? false : "ordered");
      }
    },
    [isSelected, format],
  );

  const bg = isSelected ? colors.gray0 : colors.transparent;

  return (
    <Button
      variant="hover"
      size="sm"
      aria-label="Format text as ordered list"
      tabIndex={-1}
      onMouseDown={onMouseDown}
      px={0}
    >
      <OrderedListIcon
        boxSize={5}
        fill={colors.gray40}
        bg={bg}
        borderRadius={4}
      />
    </Button>
  );
};

export default memo(ComposeQuillOrderedList);
